import {
  X_THERAME_CALL_SESSION,
  X_THERAME_CAREGIVER_ID,
  X_THERAME_OFFICE_ID,
} from '@therame/shared';
import type { ManagerOptions, SocketOptions } from 'socket.io-client';

/**
 * `officeId` is the tab's Active office and `caregiverId` the entry it acts
 * through: the socket acts as that Person, resolved like an HTTP request
 * (#1822, #1841).
 */
const getDefaulSocketConfig = (
  token?: string,
  officeId?: string | null,
  caregiverId?: string | null,
): Partial<ManagerOptions & SocketOptions> => {
  return {
    transports: ['polling', 'websocket'],
    withCredentials: true,
    autoConnect: false,
    extraHeaders: {
      Authorization: token ? `Bearer ${token}` : '',
      ...(officeId ? { [X_THERAME_OFFICE_ID]: officeId } : {}),
      ...(caregiverId ? { [X_THERAME_CAREGIVER_ID]: caregiverId } : {}),
    },
  };
};

/**
 * A TAN tab's calls socket (#1856): the call token instead of a bearer, and no
 * office header — the token names the Person, and its office is the tab's.
 */
const getCallSessionSocketConfig = (
  callSessionToken: string,
): Partial<ManagerOptions & SocketOptions> => {
  return {
    transports: ['polling', 'websocket'],
    withCredentials: true,
    autoConnect: false,
    extraHeaders: { [X_THERAME_CALL_SESSION]: callSessionToken },
  };
};

export { getCallSessionSocketConfig, getDefaulSocketConfig };
